import React from 'react';
import BannerCarousel from '../MobileComponents/BannerCarousel/index';
// import PreferenceCards from '../MobileComponents/PreferenceCards';
import SingleBanner from '../MobileComponents/SingleBanner/index';
import Description from '../MobileComponents/Description/index';
import Focus from '../MobileComponents/Focus/index';
// import Colapse from '../MobileComponents/Colapse';
import RedirectMenu from '../MobileComponents/RedirectMenu/index';
import MediaYoutube from '../MobileComponents/MediaYoutube/index';
// import Topic from '../MobileComponents/Topic';
// import Card from '../MobileComponents/Card';
import ProductTable from '../MobileComponents/ProductTable';
import InfiniteScroll from '../MobileComponents/InfiniteScroll';
import UniqueProduct from '../MobileComponents/UniqueProduct';
import ProductCarouselQuery from '../MobileComponents/ProductCarouselQuery';
import VtexCollectionPhone from '../MobileComponents/VtexCollection/index';
import ProductsCarousel from '../MobileComponents/ProductsCarousel/index';
import RedirectTitle from '../MobileComponents/RedirectTitle/index';
import HighlightFilter from '../MobileComponents/HighlightFilter';
import BannersCols from '../MobileComponents/BannersCols/index';
// import BannersMosaic from '../MobileComponents/BannersMosaic/index';
import CarouselStories from '../MobileComponents/CarouselStories/index';
// import PromotionalBannersCarousel from '../MobileComponents/PromotionalBannerCarousel/index';
// import MosaicBannerCarouselVertical from '../MobileComponents/MosaicBannerCarouselVertical';
// import MosaicBannerCarousel from '../MobileComponents/MosaicBannerCarousel';

const components: { [key: string]: React.FC<any> } = {
  'banner-unico': SingleBanner,
  // 'banners-col': BannersCols,
  'banners-em-coluna': BannersCols,
  'banners-em-colunas': BannersCols,
  // 'banners-mosaic': BannersMosaic,
  // 'mosaico-de-banners': BannersMosaic,
  'carrossel-de-stories': CarouselStories,
  'carrossel-de-banner': BannerCarousel,
  // 'cards-de-preferencias': PreferenceCards,
  // 'carrosel-de-banner-promocional': PromotionalBannersCarousel,
  'carrossel-de-produtos': ProductsCarousel,
  'carrossel-de-produtos-query': ProductCarouselQuery,
  // 'banner-unico-countdown': SingleBanner,
  // 'carrossel-de-banner-mosaico': MosaicBannerCarousel,
  // 'carrossel-de-banner-mosaico-vertical': MosaicBannerCarouselVertical,
  // description: Description,
  'texto-de-descricao': Description,
  // 'redirect-title': RedirectTitle,
  'titulo-com-redirecionamento': RedirectTitle,
  // focus: Focus,
  'texto-de-foco': Focus,
  // colapse: Colapse,
  // colapsavel: Colapse,
  // 'redirect-menu': RedirectMenu,
  'links-redirecionaveis': RedirectMenu,
  // 'highlight-filter': HighlightFilter,
  'filtro-destaque': HighlightFilter,
  'colecao-vtex': VtexCollectionPhone,
  'media-youtube': MediaYoutube,
  // topic: Topic,
  // topicos: Topic,
  // card: Card,
  // 'card-de-topicos': Card,
  // 'table-products': ProductTable,
  'tabela-de-produtos': ProductTable,
  // 'infinite-scroll': InfiniteScroll,
  'scroll-infinito': InfiniteScroll,
  // 'unique-product': UniqueProduct,
  'produto-unico': UniqueProduct,
};

export default components;
